import React from "react";
import ReactDOM from "react-dom/client";
import "./Styles/index.scss";
import "./Styles/font.scss";
import "./Styles/color.scss";

import reportWebVitals from "./reportWebVitals";
import { CelenoraComponent } from "./CelenoraComponent/CelenoraComponent";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <CelenoraComponent />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
